import clsx from 'clsx';

import { TSource } from '@northladder/services';

import { SectionContainer } from './SectionContainer';
// import './style.css';
import { ITimelineFeedBarProps, TimelineFeedBar } from './TimelineFeedBar';
import {
  ITransactionSnapshotProps,
  TransactionSnapshot,
} from './TransactionSnapshot/TransactionSnapshot';

export interface IRequestTrackerRecordProps {
  source: TSource;
  timeline: ITimelineFeedBarProps;
  transaction: ITransactionSnapshotProps;
}

/**
 * -----------------------------------------------------------------------------
 * It renders a timeline with icon and a card with transaction details
 */
export function RequestTrackerRecord({
  source,
  timeline,
  transaction,
}: Readonly<IRequestTrackerRecordProps>) {
  return (
    <div className={clsx('request-tracker-record flex gap-2', source)}>
      <TimelineFeedBar {...timeline} />
      <SectionContainer>
        <TransactionSnapshot {...transaction} />
      </SectionContainer>
    </div>
  );
}
